import React from 'react';

import logo from '../../assets/thalo_logo.png';

import './EventDetailPlaceholder.scss';

const EventDetailPlaceholder = () => {
	return (
		<div className="EventDetailPlaceholder">
			<div className="left">
				<img src={logo} className="logo" alt="thalo logo" />
			</div>
			<div className="overlay" />
		</div>
	);
};

export default EventDetailPlaceholder;
